import type {SxProps, Theme} from '@mui/material';

/**
 * Shared `fullScreen`-aware style factories for `CropPanel`. Centralising
 * these keeps the `fullScreen ? A : B` responsive rules in one place instead
 * of duplicated inline across every styled element in the component.
 */

export const getCropPanelRootSx = (fullScreen: boolean): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  gap: fullScreen ? 0 : 2,
  width: '100%',
  height: fullScreen ? '100%' : undefined,
  minHeight: 0,
});

/** iOS Photos-style: the image fills all available space and stays centered. */
export const getCropStageSx = (fullScreen: boolean): SxProps<Theme> => ({
  width: '100%',
  height: fullScreen ? undefined : {xs: 280, sm: 360},
  flex: fullScreen ? 1 : undefined,
  minHeight: 0,
  display: fullScreen ? 'flex' : undefined,
  alignItems: fullScreen ? 'center' : undefined,
  justifyContent: fullScreen ? 'center' : undefined,
  bgcolor: fullScreen ? 'common.black' : undefined,
  overflow: 'hidden',
});

export const getCropErrorSx = (fullScreen: boolean): SxProps<Theme> | undefined =>
  (fullScreen ? {px: 2, pt: 1} : undefined);

export const getCropActionBarSx = (fullScreen: boolean): SxProps<Theme> => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1,
  p: fullScreen ? 2 : undefined,
  bgcolor: fullScreen ? 'background.paper' : undefined,
});

